import HoverTippable from "src/components/StoryBible/HoverTippable";
import GenerateProseGoButton from "src/components/StoryBible/GenerateProseGoButton";

function DisabledGenerateProseButton() {
  return (
    <HoverTippable
      generateDisabled={true}
      generateDisabledMessage={"A generation is already in progress"}
    >
      <GenerateProseGoButton generateDisabled={true} />
    </HoverTippable>
  );
}

export default DisabledGenerateProseButton;
